import layoutHeaderAside from '@/layout/header-aside';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/cloud/',
  name: 'cloud',
  meta: {
    auth: true
  },
  redirect: {
    name: 'cloud-index'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'h5',
      name: `${pre}h5`,
      component: _import('cloud/h5'),
      meta: {
        title: 'H5编辑'
      }
    }
  ])('cloud-')
}
